<template>
  <div>
    <div class="form-fields col-md">
      <fieldset>
        <legend>{{title}}</legend>

        <br />

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="control-label">
                The Cook County Demolition Debris Diversion (DDD) Ordinance (Sec. 30-769 through 30-775) requires reuse and recycling of demolition debris consistent with the Cook County Solid Waste Plan. Demolition debris diversion shall be required for all demolition activities affecting any structure except garages, sheds, utilities, and projects that are not demolishing any load bearing walls.
                Prior to the commencement of a demolition project, the demolition permit holder must submit a Demolition Debris Diversion Plan, estimating the respectively required diversion goals and the transport means and destinations of demolition debris.
              </label>
            </div>
          </div>
        </div>
        <base-checkbox v-model="form.exempt"
                       label="Please check this box if your demolition activity is limited to residential garages and sheds, utilities, or projects that do not involve demolishing any load-bearing walls. If your project involves any other types of structures, this exemption does not apply, and you must complete this page."
                       :readonly="readonly">
        </base-checkbox>
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">
                Please enter the overall total estimated weight of demolition debris for this project below:
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label class="required">Amount</label>
            <div class="form-group">
              <div class="input-group">
                <input type="number"
                       class="form-control"
                       placeholder="0.00"
                       :disabled="isReadOnly || isexempt()"
                       :class="{ 'is-invalid': (isTotalPercentageError(index) || isMaterialSumGreaterError()) && !isexempt() }"
                       min="0"
                       v-model="form.materialEstimate" />
                <div class="invalid-feedback" v-if="isTotalPercentageError(index) && !isexempt()">
                  Estimates for diversion are required to be at least 70% of the total estimated weight
                </div>
                <div class="invalid-feedback" v-if="isTotalZeroError(index) && !isexempt()">
                  Estimate must be greater than zero
                </div>
                <div class="invalid-feedback" v-if="isMaterialSumGreaterError() && !isexempt()">
                  Must be greater than or equal to total material amounts
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <label>Measure</label>
            <div class="form-group">
              <div class="input-group">
                <input type="text"
                       class="form-control"
                       disabled
                       placeholder="Tons" />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">
                Please enter the estimated demolition diversion quantities, by material, below. Please note, the estimates for diversion are required to be at least 70% of the total estimated weight:
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3" v-for="(material, index) in form.materials">
          <b-button v-on:click="openMaterial(index);" variant="primary">Material {{index + 1}} </b-button>
          <b-collapse :id="`collapse-${index}`" class="mt-2">
            <b-card>
              <div class="row">
                <div class="col-6">
                  <label class="required">Name</label>
                  <div class="form-group">
                    <div class="input-group">
                      <select class="form-control"
                              :disabled="isReadOnly || isexempt()"
                              :class="{ 'is-invalid': isMaterialNameError(index) && !isexempt() }"
                              @change="resetMaterialOverrideName(index)"
                              v-model="material.materialType">
                        <option v-for="m in materials">{{m.name}}</option>
                      </select>
                      <div class="invalid-feedback" v-if="isMaterialNameError(index) && !isexempt()">
                        A Name Is Required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <label class="required">Amount</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="number"
                             class="form-control"
                             placeholder="0.00"
                             min="0"
                             v-on:change="removeNegative(index)"
                             :disabled="isReadOnly || isexempt()"
                             :class="{ 'is-invalid': isMaterialAmountError(index) && !isexempt()}"
                             v-model="material.quantityEstimate" />
                      <div class="invalid-feedback" v-if="isMaterialAmountError(index) && !isexempt()">
                        An Amount Is Required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <label>Measure</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text"
                             class="form-control"
                             v-model="material.unitofMeasure"
                             disabled
                             placeholder="Tons" />
                    </div>
                  </div>
                </div>
                <div v-if="!isReadOnly">
                  <div class="col-1" v-if="!isexempt()">
                    <label></label>
                    <div class="form-group mt-2">
                      <button class="btn btn-danger" title="Remove Item" v-on:click="removeMaterial(index);" v-b-tooltip.hover>
                        <font-awesome-icon icon="times" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6" v-if="material.materialType === 'Other'">
                  <label></label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text"
                             class="form-control"
                             placeholder="Material Name / Description"
                             :disabled="isReadOnly || isexempt()"
                             :class="{ 'is-invalid': isMaterialOverrideNameError(index) && !isexempt() }"
                             v-model="material.overrideName" />
                      <div class="invalid-feedback" v-if="isMaterialOverrideNameError(index) && !isexempt()">
                        A Value Is Required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="required">Recycling Facility Name</label>
                  <vue-simple-suggest :list="facilities"
                                      mode="input"
                                      v-model="material.facilityName"
                                      :placeholder="'Recycling Facility Name'"
                                      value-attribute="id"
                                      display-attribute="name"
                                      :filter-by-query="true"
                                      @select="facilitySelected">
                    <div class="input-group">
                      <input :class="{ 'is-invalid': isFacilityNameError(index) && !isexempt() }" type="text" :disabled="isexempt()" class="form-control" v-model="material.facilityName" @change="facilitySelected(null)" />
                    </div>
                    <div class="invalid-feedback" v-if="isFacilityNameError(index) && !isexempt()">
                      A valid facility must be selected
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <br />

        <div v-if="!isReadOnly">
          <div class="row" v-if="!isexempt()">
            <div class="col">
              <div class="form-group">
                <button class="btn btn-primary" v-on:click="addMaterial();">
                  <font-awesome-icon icon="plus" />&nbsp;Add Additional Material(s)
                </button>
              </div>
            </div>
          </div>
        </div>

        <br />

      </fieldset>
      <label>To convert Pounds to Tons, divide pounds by 2000. To convert Cubic Yards to Tons, multiply cubic yards by 1.4</label>
    </div>
    <bottom-navigation link="signature">Signature</bottom-navigation>
  </div>
</template>
<script>
  import BaseInput from '~/components/BaseInput'
  import ExplodedFieldset from '~/components/ExplodedFieldset'
  import VAddress from '~/components/VAddress'
  import BottomNavigation from '~/components/BottomNavigation'
  import BaseTimePicker from '~/components/BaseTimePicker'
  import BaseDatePicker from '~/components/BaseDatePicker'
  import BaseCheckbox from '~/components/BaseCheckbox'
  import BaseTextarea from '~/components/BaseTexarea'
  import YesNo from '~/components/YesNo'
  import { getFacilities, getMaterials, capitalize, isNullOrEmpty } from '~/js/FormFunctions'
  import { CapitalizeFilter } from '@/js/Mixins'
  import VueSimpleSuggest from 'vue-simple-suggest'
  import BaseSelect from '~/components/BaseSelect'
  import BaseFileUploader from '~/components/BaseFileUploader'
  import { Material } from '../../js/FormObjects'


  export default {
    name: 'Facility',
    components: {
      BaseFileUploader,
      BaseSelect,
      BaseInput,
      ExplodedFieldset,
      VAddress,
      BottomNavigation,
      VueSimpleSuggest,
      BaseTimePicker,
      YesNo,
      BaseDatePicker,
      BaseTextarea,
      BaseCheckbox
    },
    props: ['form', 'val', 'stateList'],
    mixins: [CapitalizeFilter],
    data() {
      return {
        facilities: [],
        materials: [],
        currMaterialIndex: 0,
        partialFullDemoOptions: [
          { value: null, text: '' },
          { value: 'F', text: 'Full Demolition' },
          { value: 'P', text: 'Partial Demolition' }
        ],
        autosuggestProps: {
          id: 'facility-suggest',
          onInputChange: this.inputChange
        }
      }
    },
    mounted() {
      this.$emit('update:title', 'Demolition Debris Diversion Ordinance Plan')
      this.facilities = this.$store.getters.facilities()
      if (!this.facilities || this.facilities.length === 0) {
        const self = this
        this.$emit('update:fetchingData', true)
        getFacilities()
          .then((response) => {
            self.facilities = response
            self.$emit('update:fetchingData', false)

            for (var i = 0; i < this.$props.form.materials.length; i++) {
              this.$props.form.materials[i].facilityName = self.facilities.find(o => o.id === this.$props.form.materials[i].linktoRecyclingFacility).name
            }
          })
          .catch(() => {
            self.$emit('update:fetchingData', false)
          })
      }

      this.materials = this.$store.getters.materials()
      if (!this.materials || this.materials.length === 0) {
        const self = this
        this.$emit('update:fetchingData', true)
        getMaterials()
          .then((response) => {
            self.materials = response
            self.$emit('update:fetchingData', false)
          })
          .catch(() => {
            self.$emit('update:fetchingData', false)
          })
      }
    },
    methods: {
      // this is silly
      capitalize: function (lowercase) {
        return capitalize(lowercase)
      },
      facilitySelected: function (facility) {
        //get current material and update facility info
        if (!facility) {
          this.$props.form.materials[this.currMaterialIndex].linktoRecyclingFacility = null
        } else {
          this.$props.form.materials[this.currMaterialIndex].linktoRecyclingFacility = facility.id
        }
      },
      isFacilityNameError(index) {
        if (!this.$props.form.materials[index]) {
          return false;
        }
        return isNullOrEmpty(this.$props.form.materials[index].linktoRecyclingFacility);
      },
      isMaterialNameError(index) {
        if (!this.$props.form.materials[index]) {
          return false;
        }
        return isNullOrEmpty(this.$props.form.materials[index].materialType);
      },
      isTotalPercentageError(index) {
        let sum = 0;
        this.$props.form.materials.forEach((material) => {
          sum = +sum + +material.quantityEstimate
        })
        return ((sum / this.$props.form.materialEstimate) * 100) < 70;
      },
      isTotalZeroError() {
        return this.$props.form.materialEstimate <= 0;
      },
      isMaterialSumGreaterError() {
        let sum = 0;
        this.$props.form.materials.forEach((material) => {
          sum = +sum + +material.quantityEstimate
        })
        return sum > this.$props.form.materialEstimate;
      },
      isMaterialAmountError(index) {
        return isNullOrEmpty(this.$props.form.materials[index].quantityEstimate);
      },
      isexempt() {
        return this.$props.form.exempt;
      },
      removeNegative(index) {
        this.$props.form.materials[index].quantityEstimate = this.$props.form.materials[index].quantityEstimate.replace('-', '')
      },
      addMaterial() {
        this.$props.form.materials.push(new Material());
      },
      removeMaterial(index) {
        this.$props.form.materials.splice(index, 1);
      },
      isMaterialOverrideNameError(index) {
        if (this.$props.form.materials[index].materialType != 'Other') return false;

        return isNullOrEmpty(this.$props.form.materials[index].overrideName);
      },
      resetMaterialOverrideName(index) {
        if (this.$props.form.materials[index].name != 'Other') {
          this.$props.form.materials[index].overrideName = '';
        }
      },
      openMaterial(index) {
        this.currMaterialIndex = index
        document.getElementById('collapse-' + index).style.display = 'block'
        document.getElementById('collapse-' + index).classList.add('show')

        var i = 0;
        while (document.getElementById('collapse-' + i)) {
          if (i != index) {
            document.getElementById('collapse-' + i).style.display = 'none'
            document.getElementById('collapse-' + i).classList.remove('show')
          }

          i++
        }
      }
    },
    computed: {
      isVariance: function () {
        return this.form.varianceCheckPublicHealth ||
          this.form.varianceCheckFinancialBurden ||
          this.form.varianceCheckCourtOrder
      }
    }
  }
</script>
<style lang="scss" scoped>
  .invalid-feedback {
    display: block;
  }
</style>
